import { Injectable } from '@angular/core';
import { ReqService } from './req.service';

@Injectable()
export class I18nService {
  public translations: any;
  private locale: string;

  constructor(public reqService: ReqService) {
    this.locale = this.reqService.getLocale();

    this.translations = {
      'es-AR': {
        Buscar: 'Buscar',
        Encontramos: 'Encontramos',
        'alojamientos disponibles': 'alojamientos disponibles',
        'alojamiento disponible': 'alojamiento disponible',
        Ene: 'Ene',
        Feb: 'Feb',
        Mar: 'Mar',
        Abr: 'Abr',
        May: 'May',
        Jun: 'Jun',
        Jul: 'Jul',
        Ago: 'Ago',
        Sep: 'Sep',
        Oct: 'Oct',
        Nov: 'Nov',
        Dic: 'Dic',
        'first-section': 'hoteles',
        'section-detail': 'detalle',
        'section-destination': 'destinos',
        'hotels-in': 'hoteles-en',
        '400001': 'La fecha de ingreso es obligatoria',
        '400002': 'La fecha de salida es obligatoria',
        '400003': 'Existe un error en la URL',
        '400004': 'El formato de la fecha de ingreso es inválido',
        '400005': 'El formato de la fecha de salida es inválido',
        '400006':
          'El tiempo de estadía debe ser menor a las 27 noches. Por favor intentá una nueva búsqueda',
        '400007': 'La fecha de ingreso debe ser anterior a la fecha de salida',
        '400008': 'La fecha de ingreso es igual a la fecha de salida',
        '400009':
          'La fecha de ingreso debe ser, como mínimo, 2 días posterior al día de hoy. Por favor intentá una nueva búsqueda',
        '400010': 'Existe un error en la URL',
        '400011': 'El Site es obligatorio',
        '400012': 'Existe un error en la URL',
        '400013': 'Existe un error en la URL',
        '400014': 'El ID del hotel no existe',
        generic: 'Por favor intentá una nueva busqueda.',
        al: 'al',
        'Ticket Magia a Tu Manera': 'Ticket Magia a Tu Manera',
        días: 'días',
        'con opción': 'con opción',
        básico: 'básico',
        GRATIS: 'GRATIS',
        fotos: 'Fotos',
        informacion: 'Información',
        seleccion: 'Selección',
        comentarios: 'Comentarios',
        'este campo es obligatorio': 'Este campo es obligatorio',
        DISNEY_QUICK_DINING: 'Rápidas',
        DISNEY_DINING: 'Básico',
        DISNEY_DELUXE: 'De lujo',
        o: 'o',
        sorting_recommended: 'Más Vendidos',
        sorting_price_ASC: 'Precio más bajo',
        sorting_price_DESC: 'Precio más alto',
        sorting_stars_ASC: 'Menos estrellas',
        sorting_stars_DESC: 'Más estrellas',
        sorting_rating_DESC: 'Mejor Puntuación',
      },
      'es-CO': {
        Buscar: 'Buscar',
        Encontramos: 'Encontramos',
        'alojamientos disponibles': 'alojamientos disponibles',
        'alojamiento disponible': 'alojamiento disponible',
        Ene: 'Ene',
        Feb: 'Feb',
        Mar: 'Mar',
        Abr: 'Abr',
        May: 'May',
        Jun: 'Jun',
        Jul: 'Jul',
        Ago: 'Ago',
        Sep: 'Sep',
        Oct: 'Oct',
        Nov: 'Nov',
        Dic: 'Dic',
        'first-section': 'hoteles',
        'section-detail': 'detalle',
        'section-destination': 'destinos',
        'hotels-in': 'hoteles-en',
        '400001': 'La fecha de ingreso es obligatoria',
        '400002': 'La fecha de salida es obligatoria',
        '400003': 'Existe un error en la URL',
        '400004': 'El formato de la fecha de ingreso es inválido',
        '400005': 'El formato de la fecha de salida es inválido',
        '400006':
          'El tiempo de estadía debe ser menor a las 27 noches. Por favor intenta una nueva búsqueda',
        '400007': 'La fecha de ingreso debe ser anterior a la fecha de salida',
        '400008': 'La fecha de ingreso es igual a la fecha de salida',
        '400009':
          'La fecha de ingreso debe ser, como mínimo, 2 días posterior al día de hoy. Por favor intentá una nueva búsqueda',
        '400010': 'Existe un error en la URL',
        '400011': 'El Site es obligatorio',
        '400012': 'Existe un error en la URL',
        '400013': 'Existe un error en la URL',
        '400014': 'El ID del hotel no existe',
        generic: 'Por favor intentá una nueva busqueda.',
        al: 'al',
        'Ticket Magia a Tu Manera': 'Ticket Magia a Tu Manera',
        días: 'días',
        'con opción': 'con opción',
        básico: 'básico',
        GRATIS: 'GRATIS',
        fotos: 'Fotos',
        informacion: 'Información',
        seleccion: 'Selección',
        comentarios: 'Comentarios',
        'este campo es obligatorio': 'Este campo es obligatorio',
        DISNEY_QUICK_DINING: 'Rápidas',
        DISNEY_DINING: 'Básico',
        DISNEY_DELUXE: 'De lujo',
        o: 'o',
        sorting_recommended: 'Más Vendidos',
        sorting_price_ASC: 'Precio más bajo',
        sorting_price_DESC: 'Precio más alto',
        sorting_stars_ASC: 'Menos estrellas',
        sorting_stars_DESC: 'Más estrellas',
        sorting_rating_DESC: 'Mejor Puntuación',
      },
      'es-MX': {
        Buscar: 'Buscar',
        Encontramos: 'Encontramos',
        'alojamientos disponibles': 'alojamientos disponibles',
        'alojamiento disponible': 'alojamiento disponible',
        Ene: 'Ene',
        Feb: 'Feb',
        Mar: 'Mar',
        Abr: 'Abr',
        May: 'May',
        Jun: 'Jun',
        Jul: 'Jul',
        Ago: 'Ago',
        Sep: 'Sep',
        Oct: 'Oct',
        Nov: 'Nov',
        Dic: 'Dic',
        'first-section': 'hoteles',
        'section-detail': 'detalle',
        'section-destination': 'destinos',
        'hotels-in': 'hoteles-en',
        '400001': 'La fecha de ingreso es obligatoria',
        '400002': 'La fecha de salida es obligatoria',
        '400003': 'Existe un error en la URL',
        '400004': 'El formato de la fecha de ingreso es inválido',
        '400005': 'El formato de la fecha de salida es inválido',
        '400006':
          'El tiempo de estadía debe ser menor a las 27 noches. Por favor intenta una nueva búsqueda',
        '400007': 'La fecha de ingreso debe ser anterior a la fecha de salida',
        '400008': 'La fecha de ingreso es igual a la fecha de salida',
        '400009':
          'La fecha de ingreso debe ser, como mínimo, 2 días posterior al día de hoy. Por favor intentá una nueva búsqueda',
        '400010': 'Existe un error en la URL',
        '400011': 'El Site es obligatorio',
        '400012': 'Existe un error en la URL',
        '400013': 'Existe un error en la URL',
        '400014': 'El ID del hotel no existe',
        generic: 'Por favor intentá una nueva busqueda.',
        al: 'al',
        'Ticket Magia a Tu Manera': 'Ticket Magia a Tu Manera',
        días: 'días',
        'con opción': 'con opción',
        básico: 'básico',
        GRATIS: 'GRATIS',
        fotos: 'Fotos',
        informacion: 'Información',
        seleccion: 'Selección',
        comentarios: 'Comentarios',
        'este campo es obligatorio': 'Este campo es obligatorio',
        DISNEY_QUICK_DINING: 'Rápidas',
        DISNEY_DINING: 'Básico',
        DISNEY_DELUXE: 'De lujo',
        o: 'o',
        sorting_recommended: 'Más Vendidos',
        sorting_price_ASC: 'Precio más bajo',
        sorting_price_DESC: 'Precio más alto',
        sorting_stars_ASC: 'Menos estrellas',
        sorting_stars_DESC: 'Más estrellas',
        sorting_rating_DESC: 'Mejor Puntuación',
      },
      'pt-BR': {
        Buscar: 'Buscar',
        Encontramos: 'Encontramos',
        'alojamientos disponibles': 'hospedagens disponíveis',
        'alojamiento disponible': 'hospedagem disponível',
        Ene: 'Jan',
        Feb: 'Fev',
        Mar: 'Mar',
        Abr: 'Abr',
        May: 'Mai',
        Jun: 'Jun',
        Jul: 'Jul',
        Ago: 'Ago',
        Sep: 'Set',
        Oct: 'Out',
        Nov: 'Nov',
        Dic: 'Dez',
        'first-section': 'hoteis',
        'section-detail': 'detalhe',
        'section-destination': 'destinos',
        'hotels-in': 'hoteis-em',
        '400001': 'A data de entrada é obrigatória',
        '400002': 'A data de saída é obrigatória',
        '400003': 'Existe um erro na URL',
        '400004': 'O formato da data de entrada é inválido',
        '400005': 'O formato da data de saída é inválido',
        '400006':
          'A duração da sua estadia deve ser menor que 27 noites. Por favor tente uma nova busca.',
        '400007': 'A data de entrada deve ser anterior à data de saída',
        '400008': 'A data de entrada está igual a data de saída',
        '400009':
          'A data de entrada deve ser, no mínimo, 2 dias posterior ao dia de hoje. Por favor tente uma nova busca',
        '400010': 'Existe um erro na URL',
        '400011': 'O site é obrigatório',
        '400012': 'Existe um erro na URL',
        '400013': 'Existe um erro na URL',
        '400014': 'O ID do hotel não existe',
        generic: 'Por favor, tente uma nova pesquisa.',
        al: 'a',
        'Ticket Magia a Tu Manera': 'Ticket Magia á Sua Maneira',
        días: 'dias',
        'con opción': 'com Opção',
        básico: 'em 1 parque por dia',
        GRATIS: 'GRÁTIS',
        fotos: 'Fotos',
        informacion: 'Información',
        seleccion: 'Seleção',
        comentarios: 'Comentários',
        'este campo es obligatorio': 'Este campo é obrigatório',
        DISNEY_QUICK_DINING: 'Rápidas',
        DISNEY_DINING: 'Básico',
        DISNEY_DELUXE: 'De luxo',
        o: 'ou',
        sorting_recommended: 'Mais Vendidos',
        sorting_price_ASC: 'Menor preço',
        sorting_price_DESC: 'Maior preço',
        sorting_stars_ASC: 'Menos estrelas',
        sorting_stars_DESC: 'Mais estrellas',
        sorting_rating_DESC: 'Melhor Avaliação',
      },
    };
  }

  public translate(key: string): string {
    if (
      this.translations &&
      this.translations[this.locale] &&
      this.translations[this.locale][key]
    ) {
      return this.translations[this.locale][key];
    } else {
      return key;
    }
  }
}
